'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _imgs = require('./imgs.js');

var _imgs2 = _interopRequireDefault(_imgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    content: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '' // success fail
    }
  },
  data: function data() {
    return {
      isShow: false
    };
  },

  computed: {
    icon: function icon() {
      return _imgs2.default[this.type] || '';
    }
  },
  methods: {
    showToast: function showToast() {
      var _this = this;

      if (this.isShow === false) {
        this.isShow = true;
        setTimeout(function () {
          _this.isShow = false;
        }, 2000);
      }
    }
  }
}; //
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-toast/index.vue
// module id = 416
// module chunks = 0 1